import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers'
import { ThemeProvider } from '@mui/material/styles'
import CustomLuxonAdapter from 'lib/CustomLuxonAdapter'
import ScheduleRow from 'pages/pga-coach/dashboard/todays-schedule/schedule-row'
import useScheduleStyles from 'pages/pga-coach/dashboard/todays-schedule/styles'
import { calendarDatePickerTheme } from './calendar-date-picker-theme'
import CalendarAgendaDay from './calendar-agenda-day'
import {
  calendarDateCalendarSlots,
  calendarDateCalendarSlotProps,
} from './calendar-date-calendar-slots'
import { getBookingEventKey } from './calendar-utils'
import useCalendarStyles from './calendar-styles'

const CalendarMobileAgendaView = ({
  anchorDate,
  onDateChange,
  bookingsByDate,
  onReschedule,
  onPayment,
  onCancellation,
}) => {
  const classes = useCalendarStyles()
  const scheduleClasses = useScheduleStyles()
  const dateKey = anchorDate.toISODate()
  const dayBookings = bookingsByDate[dateKey] || []

  const handleMonthChange = nextMonth => {
    if (!nextMonth) {
      return
    }

    onDateChange(
      nextMonth.set({
        day: Math.min(anchorDate.day, nextMonth.daysInMonth),
      }),
    )
  }

  return (
    <>
      <Box className={classes.mobileAgendaCalendar}>
        <ThemeProvider theme={calendarDatePickerTheme}>
          <LocalizationProvider dateAdapter={CustomLuxonAdapter} locale="en-us">
            <DateCalendar
              value={anchorDate}
              onChange={date => {
                if (date) {
                  onDateChange(date)
                }
              }}
              onMonthChange={handleMonthChange}
              dayOfWeekFormatter={day => `${day}`}
              reduceAnimations
              className={clsx(classes.dateCalendar, classes.mobileDateCalendar)}
              slots={{
                ...calendarDateCalendarSlots,
                day: CalendarAgendaDay,
              }}
              slotProps={{
                ...calendarDateCalendarSlotProps,
                day: { bookingsByDate },
              }}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </Box>

      <Box className={classes.listSection}>
        <Typography className={classes.listSectionHeader}>
          {anchorDate.toFormat('cccc, LLLL d')}
        </Typography>
        {dayBookings.length > 0 ? (
          <Box className={`${scheduleClasses.list} ${classes.listRows}`}>
            {dayBookings.map(booking => (
              <ScheduleRow
                key={getBookingEventKey(booking)}
                booking={booking}
                onReschedule={onReschedule}
                onPayment={onPayment}
                onCancellation={onCancellation}
                showDateLabel={false}
              />
            ))}
          </Box>
        ) : (
          <Typography className={classes.listSectionEmpty}>
            Nothing scheduled.
          </Typography>
        )}
      </Box>
    </>
  )
}

CalendarMobileAgendaView.propTypes = {
  anchorDate: PropTypes.object.isRequired,
  onDateChange: PropTypes.func.isRequired,
  bookingsByDate: PropTypes.object.isRequired,
  onReschedule: PropTypes.func,
  onPayment: PropTypes.func,
  onCancellation: PropTypes.func,
}

export default CalendarMobileAgendaView
